import { useRef } from "react";
import classes from "./BaseLoginInput.module.css";

export function BaseLoginInput({
  type,
  name,
  onChange,
  value,
  label,
  onInput,
}) {
  const inputRef = useRef(null);

  function handleFocusClick() {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }

  return (
    <div className={classes.input} onClick={handleFocusClick}>
      <label htmlFor={name}>{label}</label>
      <input
        ref={inputRef}
        type={type}
        name={name}
        id={name}
        value={value}
        onChange={onChange}
        onInput={onInput}
        required
      />
    </div>
  );
}
